// src/utils/archiveScope.js
//
// Kapsam seçicileri (şehir → lig → sezon) arşivdeki kayıtları listelemez;
// /api/meta uçları varsayılan olarak arşivi gizler. Ancak kullanıcı arşiv
// sayfasından arşivlenmiş bir lig/sezon adresine girdiğinde, o kayıt listede
// bulunamadığı için varsayılan (aktif) kapsama yönlendirilirdi.
//
// Buradaki yardımcılar, adreste istenen kayıt aktif listede yoksa arşivi de
// kapsayan ikinci bir istek atıp yalnızca O kaydı listeye ekler. Böylece
// arşivdeki sayfa açık kalır, seçicide "(Arşiv)" etiketiyle görünür; diğer
// arşiv kayıtları listeye sızmaz.

export const toScopeId = (value) => (value === undefined || value === null ? "" : String(value).trim());

export const isArchivedOption = (entity) => {
  if (!entity) return false;
  const raw = entity.is_archived ?? entity.isArchived ?? entity.archived;
  if (raw === undefined || raw === null) return false;
  if (typeof raw === "string") {
    const normalized = raw.trim().toLocaleLowerCase("tr-TR");
    return ["1", "true", "evet", "yes"].includes(normalized);
  }
  return Boolean(raw);
};

/** Seçicide arşiv kaydını ayırt etmek için etiket. */
export const scopeOptionLabel = (entity, fallback = "") => {
  const label = String(entity?.label ?? fallback ?? "").trim();
  return isArchivedOption(entity) ? `${label} (Arşiv)` : label;
};

/**
 * Adreste istenen kayıt aktif listede yoksa arşivden çekip listeye ekler.
 *
 * @param {object[]} list         Aktif kayıtlar (/api/meta yanıtı)
 * @param {string}   requestedId  URL'den gelen id
 * @param {function} fetchWithArchive  Arşiv dahil listeyi döndüren fonksiyon
 * @returns {Promise<object[]>}   Gerekiyorsa arşiv kaydı eklenmiş liste
 */
export async function ensureRequestedScope(list, requestedId, fetchWithArchive) {
  const safeList = Array.isArray(list) ? list : [];
  const id = toScopeId(requestedId);
  if (!id) return safeList;
  if (safeList.some((item) => toScopeId(item?.id) === id)) return safeList;

  try {
    const all = await fetchWithArchive();
    const found = (Array.isArray(all) ? all : []).find((item) => toScopeId(item?.id) === id);
    if (!found) return safeList;
    return [...safeList, { ...found, is_archived: true }];
  } catch (error) {
    // Arşiv sorgusu başarısızsa aktif listeyle devam et; sayfa yine de açılır.
    return safeList;
  }
}
